__webpack_require__.p = "https://higherlogiccloudfront.s3.amazonaws.com/ai-assistant/6.1.2/";